import { memo } from 'react';
import { AdminFormRow } from '@ui';
import { ControlledTextInput } from '@lp/features/admin/forms/components/inputs/ControlledTextInput';

type HubBasicDetailsProps = {
  isReadOnly?: boolean;
};

export const HubBasicDetails = memo(({ isReadOnly }: HubBasicDetailsProps) => {
  return (
    <>
      <AdminFormRow title="NOP Hub Name" isRequired>
        <ControlledTextInput name="name" aria-label="NOP Hub Name" isDisabled={isReadOnly} />
      </AdminFormRow>
      <AdminFormRow title="Code" isRequired>
        <ControlledTextInput name="code" aria-label="Code" isDisabled={isReadOnly} />
      </AdminFormRow>
    </>
  );
});
